var _path, _path2, _path3, _circle, _circle2, _line, _g, _circle3, _line2, _g2, _circle4, _circle5, _line3, _g3, _circle6, _line4, _g4, _circle7, _line5, _g5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1349,
    height: 498,
    viewBox: "0 0 1349 498",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M508.075 222.147C296.577 490.604 23.5 497.132 23.5 497.132L1188.06 497.132L1249 497.132C1249 497.132 1189 -2.04944 1018 0.00633164C909.914 1.30575 843.314 250.858 786.162 275.17C690.476 315.874 616.129 84.9925 508.075 222.147Z",
    fill: "url(#paint0_linear_1594_115422)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M748.912 171.76C686.125 223.807 664.205 328.91 584.961 330.003C539.275 330.634 516.517 292.87 435.863 293.983C355.209 295.096 270.874 424.281 0.999956 469.469C0.999956 472.586 1.26457 496.469 1.26457 496.469H1348L1348 418.469C1250.5 229.469 1266.84 131.677 1176 132.963C1083.83 134.268 1075.24 306.031 982.356 307.313C903.803 308.397 835.362 100.097 748.912 171.76Z",
    fill: "url(#paint1_linear_1594_115422)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380.594 402.03C380.594 402.03 431.079 420.644 510.331 283.575C621.403 91.4718 704.843 421.502 812.544 369.541C876.872 338.505 925.964 183.892 971.388 118.153C1071.01 -26.0155 1163.24 343.02 1163.24 343.02",
    stroke: "url(#paint2_linear_1594_115422)",
    strokeWidth: 2.82036,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 578.584,
    cy: 220.399,
    r: 25.6653,
    fill: "url(#paint3_radial_1594_115422)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.584,
    cy: 220.399,
    r: 17.7682,
    fill: "url(#paint4_radial_1594_115422)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 579.43,
    y1: 217.296,
    x2: 579.43,
    y2: 453.642,
    stroke: "url(#paint5_linear_1594_115422)",
    strokeWidth: 2.25629,
    strokeDasharray: "10.15 10.15"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1594_115422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 578.584,
    cy: 220.399,
    r: 9.30718,
    fill: "url(#paint6_linear_1594_115422)"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 578.584,
    cy: 220.399,
    r: 25.6653,
    fill: "#E6EFFF"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 578.43,
    y1: 217.296,
    x2: 578.43,
    y2: 453.642,
    stroke: "url(#paint7_linear_1594_115422)",
    strokeWidth: 2.25629,
    strokeDasharray: "10.15 10.15"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1594_115422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 578.584,
    cy: 220.399,
    r: 9.30718,
    fill: "url(#paint8_linear_1594_115422)"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1020.25,
    cy: 82.7652,
    r: 25.6653,
    fill: "url(#paint9_radial_1594_115422)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1020.25,
    cy: 82.7652,
    r: 17.7682,
    fill: "url(#paint10_radial_1594_115422)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1021.1,
    y1: 79.6628,
    x2: 1021.1,
    y2: 453.642,
    stroke: "url(#paint11_linear_1594_115422)",
    strokeWidth: 2.25629,
    strokeDasharray: "10.15 10.15"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1594_115422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1020.25,
    cy: 82.7652,
    r: 9.30718,
    fill: "url(#paint12_linear_1594_115422)"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1020.25,
    cy: 82.7652,
    r: 25.6653,
    fill: "#D7E4FF"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1020.1,
    y1: 79.6628,
    x2: 1020.1,
    y2: 453.642,
    stroke: "url(#paint13_linear_1594_115422)",
    strokeWidth: 2.25629,
    strokeDasharray: "10.15 10.15"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1594_115422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1020.25,
    cy: 82.7652,
    r: 9.30718,
    fill: "url(#paint14_linear_1594_115422)"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 780.521,
    cy: 27.4864,
    r: 25.6653,
    fill: "#AD81FF",
    fillOpacity: 0.3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.6,
    x1: 780.367,
    y1: 24.384,
    x2: 780.367,
    y2: 339.136,
    stroke: "url(#paint15_linear_1594_115422)",
    strokeWidth: 2.25629,
    strokeLinejoin: "round",
    strokeDasharray: "10.15 10.15"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1594_115422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 780.521,
    cy: 27.4865,
    r: 9.30718,
    fill: "url(#paint16_linear_1594_115422)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1594_115422",
    x: 563.636,
    y: 205.451,
    width: 29.8957,
    height: 29.8958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.82036
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1594_115422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1594_115422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1594_115422",
    x: 551.277,
    y: 193.092,
    width: 54.6143,
    height: 54.6144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1594_115422"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.6 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1594_115422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1594_115422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1594_115422",
    x: 1005.3,
    y: 67.8173,
    width: 29.8957,
    height: 29.8958,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.82036
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1594_115422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1594_115422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1594_115422",
    x: 992.944,
    y: 55.458,
    width: 54.6143,
    height: 54.6144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1594_115422"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.6 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1594_115422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1594_115422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1594_115422",
    x: 753.214,
    y: 0.179321,
    width: 54.6143,
    height: 54.6144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1594_115422"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.505882 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1594_115422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1594_115422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1594_115422",
    x1: 596.352,
    y1: 7.00647,
    x2: 596.352,
    y2: 497.132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3173FF",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688523,
    stopColor: "#3173FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1594_115422",
    x1: 1058.35,
    y1: 159.827,
    x2: 1062.93,
    y2: 511.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3173FF",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657272,
    stopColor: "#3173FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1594_115422",
    x1: 1046.76,
    y1: 84.7396,
    x2: 387.363,
    y2: 403.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD81FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414793,
    stopColor: "#AD81FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD81FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1594_115422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(578.176 220.806) rotate(26.9657) scale(26.0535 28.3389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#8BCEFF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#205EFF",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1594_115422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(578.302 220.681) rotate(26.9657) scale(18.0371 19.6193)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#8BCEFF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#205EFF",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1594_115422",
    x1: 578.302,
    y1: 227.732,
    x2: 578.302,
    y2: 451.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#205EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#21A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21A2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1594_115422",
    x1: 583.984,
    y1: 213.686,
    x2: 584.492,
    y2: 229.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#205EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1594_115422",
    x1: 577.302,
    y1: 227.732,
    x2: 577.302,
    y2: 451.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#205EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#66E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66E1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1594_115422",
    x1: 603.054,
    y1: 191.446,
    x2: 573.483,
    y2: 236.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472611,
    stopColor: "#47A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD81FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1594_115422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1019.84 83.1726) rotate(26.9657) scale(26.0535 28.3389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#8BCEFF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#205EFF",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1594_115422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1019.97 83.0472) rotate(26.9657) scale(18.0371 19.6193)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "#8BCEFF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#205EFF",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1594_115422",
    x1: 1019.97,
    y1: 96.1751,
    x2: 1019.97,
    y2: 450.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#205EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#21A2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21A2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1594_115422",
    x1: 1025.65,
    y1: 76.052,
    x2: 1026.16,
    y2: 92.1944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#205EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1594_115422",
    x1: 1018.97,
    y1: 96.1751,
    x2: 1018.97,
    y2: 450.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#205EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#66E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66E1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1594_115422",
    x1: 1044.72,
    y1: 53.8129,
    x2: 1015.15,
    y2: 99.2539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472611,
    stopColor: "#47A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD81FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1594_115422",
    x1: 778.776,
    y1: 40.8917,
    x2: 766.635,
    y2: 41.3863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490266,
    stopColor: "#AD81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914627,
    stopColor: "#AD81FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1594_115422",
    x1: 772.19,
    y1: 26.8079,
    x2: 821.076,
    y2: -12.1258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1974,
    stopColor: "#AD81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5424,
    stopColor: "#AD81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7919,
    stopColor: "#AD81FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.1b14a9b9b3ef0f5f207fdad961a88f05.svg";
export { ForwardRef as ReactComponent };